export default __webpack_public_path__ + "static/media/user_managemnt_black.25841243.svg";